import { Address } from './address';

type Title = 'mr' | 'ms' | 'mx';

export interface User {
    id: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    createdAt?: Date;
    phone?: string;
    email?: string;
    address?: Address;
    displayName?: string;
    description?: string;
    externalUrls?: string[];
    pictureUrls?: string[];
}
